<template lang="pug">
.dropdown-menu(v-if="displayMetadata")
  .dropdown-content.content
    .dropdown-item
      p.has-text-weight-bold {{ $t("metadata.metadata") }}
    hr.dropdown-divider
    .dropdown-item
      template(v-if="description.descExists")
        p(v-if="description.numberDesc" v-html="description.numberDesc")
        hr.dropdown-divider(v-if="description.numberDesc && description.pageDesc")
        p(v-html="description.pageDesc")
      template(v-else)
        p {{ $t("metadata.notAvailable") }}
      hr.dropdown-divider
      p {{ $t("metadata.detailsReference") }}

</template>

<script>
const { messages } = require("../i18n/metadataSnippet");
const { mapGetters, mapState } = require("vuex");

export default {
    name: "MetadataSnippet",
    i18n: { messages },
    computed: {
        description() {
            let sig = {};
            if (this.current.sig.match(/\/| Ex /)) {
                const parts = this.current.sig.split(/\/| Ex /);
                sig.complete = this.current.sig;
                sig.number = parts[0].replace(/ /g, "_");
                sig.page = parts[1].replace(/ /g, "_").replace(/v$/, "");
            } else {
                sig.number = this.current.sig
            }

            let numberDesc = this.$te(`${sig.number}.description`) ? this.$t(`${sig.number}.description`) : "";
            let pageDesc = "";
            if(sig.page && this.$te(`${sig.number}.pageDescriptions.p${sig.page}`)) {
                pageDesc = this.$t(`${sig.number}.pageDescriptions.p${sig.page}`);
            }

            return { numberDesc, pageDesc, descExists: numberDesc != "" || pageDesc != "" };
        },

        ...mapGetters("toc", ["current"]),
        ...mapState("transcript", ["displayMetadata"])
    }
}
</script>